import CardProps from '../interfaces/CardProps';
import React, { PropsWithChildren, useEffect, useState } from 'react';
import IconButton from '@mui/material/IconButton';
import OpenInFullIcon from '@mui/icons-material/OpenInFull';
import Rating from '@mui/material/Rating';
import '../styles/Card.css';

const Card: React.FC<PropsWithChildren<CardProps>> = ({ review, locationId, address, showTitle, children }) => {
  const [isExpanded, setIsExpanded] = useState(false);

  useEffect(() => {
    const handleEscKey = (event: KeyboardEvent) => {
      if (event.key === 'Escape') {
        setIsExpanded(false);
      }
    };

    window.addEventListener('keydown', handleEscKey);

    return () => {
      window.removeEventListener('keydown', handleEscKey);
    };
  })

  return (
    <div className="action-card-container no-mod" id={`action-card-${locationId}-${review.id}`}>
      {
        isExpanded &&
        (
        <div className="modal">
          <div className="modal-content">
          <span className="close" style={{position: "relative", top: "-15px", right: "-5px"}} onClick={() => setIsExpanded(false)}>&times;</span>
              <div>
                <h3>Dirección: {address}</h3>
                <span>
                  <h3>Calificación:</h3>
                  <Rating name="simple-rating" value={review.score} readOnly />
                </span>
                <h5>Dirección adicional: {review.additional_details ? review.additional_details : "No especificado"}</h5>
                <p>Reseña: {review.review}</p>
                <p>Dueño Directo: {review.directOwner ? "Si" : "No"}</p>
                <p>Relación con el Dueño/Inmobiliaria: {review.relationshipWithOwner ? review.relationshipWithOwner : "No especificado"}</p>
                <p>Comentarios Positivos: {review.positiveComments ? review.positiveComments : "No especificado"}</p>
                <p>Comentarios Negativos: {review.negativeComments ? review.negativeComments : "No especificado"}</p>
              </div>
          </div>
        </div>
      )}
      <div className="card" id={`${locationId}-${review.id}`}>
        <div className="content-section">
          {showTitle && <h3>{address}</h3>}
          <span className='score-span'>
            <h3>Calificación:</h3>
            <Rating name="simple-rating" value={review.score} readOnly />
          </span>
          <h5>Dirección adicional: {review.additional_details ? review.additional_details : "No especificado"}</h5>
          <p className="review">{review.review}</p>
        </div>
        {children}
        <div className="expand-menu">
            <IconButton
              aria-label="more"
              aria-controls="long-menu"
              aria-haspopup="true"
              onClick={() => setIsExpanded(true)}
            >
              <OpenInFullIcon fontSize='small'/>
            </IconButton>
        </div>
      </div>
    </div>
  );
};

export default Card;
